// import { useState } from "react";
// import { FaBars, FaTimes } from "react-icons/fa";
// import { Link } from "react-router-dom";
// import loginToken from "../authComponents/localStorageItems/LoginTokin";
// import baseURL from "../authComponents/baseURL/BaseURL";
// import { ToastContainer, toast } from "react-toastify";
// import { Alert } from "@mui/material";

// const Navbar = ({
//   userRole,
//   userStatus,
//   canRequestReview,
//   userId,
//   setLoginPopUp,
//   isIncomepleteProfile,
// }) => {
//   const [isOpen, setIsOpen] = useState(false);
//   const toggleMenu = () => {
//     setIsOpen(!isOpen);
//   };
//   const handleLogOut = () => {
//     localStorage.removeItem("authToken");
//     window.location.reload();
//   };

//   const userIsRejected = () => {
//     return userStatus.toLowerCase() === "rejected";
//   };

//   const userResubmitted = () => {
//     return userStatus.toLowerCase() === "resubmitted";
//   };

//   const getReviewButtonClass = function () {
//     if (userIsRejected() && canRequestReview == true) {
//       return "text-white bg-gradient-to-r from-red-400 via-red-500 to-red-600 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-red-300 dark:focus:ring-red-800 shadow-lg shadow-red-500/50 dark:shadow-lg dark:shadow-red-800/80 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2";
//     } else {
//       return "text-white bg-gray-300 cursor-not-allowed font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2";
//     }
//   };

//   const getBannerText = () => {
//     if (userIsRejected()) {
//       return "Your profile is currently Rejected, Please update your profile from MyProfile Page and click this button to request admin for review of your updated infomation";
//     } else {
//       return "✅ Your review request has been sent successfully. Please wait while an admin reviews your updated information. You will be notified once a decision is made";
//     }
//   };

//   const requestAccess = async () => {
//     try {
//       const respone = await baseURL.post(
//         "/request_profile_review",
//         { user_id: userId },
//         { headers: { Authorization: `Bearer ${loginToken}` } }
//       );
//       if (respone.status == 200) {
//         toast.success(respone.data.message);
//         setTimeout(() => {
//           window.location.reload();
//         }, 1000);
//       } else {
//         console.error("Failed to update user status:");
//       }
//     } catch (error) {}
//   };

//   const getRequestAccessButton = function () {
//     if (canRequestReview) {
//       return (
//         <button
//           type="button"
//           onClick={() => {
//             requestAccess();
//           }}
//           className={getReviewButtonClass()}
//         >
//           Request Review
//         </button>
//       );
//     } else {
//       return (
//         <button type="button" className={getReviewButtonClass()}>
//           {" "}
//           {userResubmitted() ? "Request Sent" : "Request Review"}{" "}
//         </button>
//       );
//     }
//   };

//   const handleLoginPopUp = () => {
//     if (!loginToken) {
//       setLoginPopUp(true); // Show popup instead of navigating
//     }
//   };
//   return (
//     <>
//       <ToastContainer />
//       <div className="flex flex-col sticky top-0 left-0 z-50">
//         {isIncomepleteProfile && (
//           <Alert
//             severity="warning"
//             className="text-center sticky top-0 left-0 z-50"
//             sx={{ display: "flex", justifyContent: "center" }}
//           >
//             Your profile is incomplete. Please{" "}
//             <Link to="/edit-profile" style={{ textDecoration: "underline" }}>
//               update your profile
//             </Link>{" "}
//             to access all features.
//           </Alert>
//         )}
//         {(userIsRejected() || userResubmitted()) && (
//           <div className="flex row items-center justify-center gap-2 p-2 bg-gray-100">
//             <p> {getBannerText()}</p>
//             {getRequestAccessButton()}
//           </div>
//         )}
//         <nav className="bg-white shadow-md w-full">
//           <div className="mx-auto px-4 flex justify-between items-center">
//             {/* Logo Section */}
//             <Link to="/" style={{ padding: "8px 0px" }}>
//               <img src="/new_logo.png" style={{ height: "100px" }} />
//             </Link>

//             {/* Hamburger Menu for Mobile */}
//             <div className="md:hidden">
//               <button onClick={toggleMenu} className="text-2xl text-[#730000]">
//                 {isOpen ? (
//                   <FaTimes className="w-6 h-6" />
//                 ) : (
//                   <FaBars className="w-6 h-6" />
//                 )}
//               </button>
//             </div>

//             {/* Navigation Links */}
//             <ul
//               className={`md:flex md:space-x-4 text-black text-sm max-md:text-[16px] uppercase font-semibold absolute md:static left-0 w-full md:w-auto bg-white md:bg-transparent md:py-0 py-4 transition-all duration-300 ease-in-out ${
//                 isOpen ? "top-16 opacity-100" : "-top-96 opacity-0"
//               } md:opacity-100`}
//             >
//               <Link to="/">
//                 <li className="hover:text-[#730000] cursor-pointer text-center md:text-left py-2">
//                   Home
//                 </li>
//               </Link>
//               <Link to="/about">
//                 <li className="hover:text-[#730000] cursor-pointer text-center md:text-left py-2">
//                   About
//                 </li>
//               </Link>
//               <Link to="/contact">
//                 <li className="hover:text-[#730000] cursor-pointer text-center md:text-left py-2">
//                   Contact Us
//                 </li>
//               </Link>
//               <Link to="/profile">
//                 <li
//                   onClick={handleLoginPopUp}
//                   className="hover:text-[#730000] cursor-pointer text-center md:text-left py-2"
//                 >
//                   My Profile
//                 </li>
//               </Link>
//               {/* Conditional Rendering */}
//               {loginToken && userRole === "admin" && (
//                 <Link to="/admin/dashboard">
//                   <li className="text-white rounded bg-[#730000] py-2 px-4 cursor-pointer text-center md:text-left">
//                     Dashboard
//                   </li>
//                 </Link>
//               )}

//               {!loginToken ? (
//                 <Link to="/login">
//                   <li
//                     className="text-white rounded bg-[#730000] py-2 px-4 cursor-pointer text-center md:text-left"
//                     style={{ fontFamily: "serif" }}
//                   >
//                     Login/Register
//                   </li>
//                 </Link>
//               ) : (
//                 <button
//                   onClick={handleLogOut}
//                   className="text-white rounded bg-[#730000] py-2 px-4 cursor-pointer text-center md:text-left"
//                 >
//                   Logout
//                 </button>
//               )}
//             </ul>
//           </div>
//         </nav>
//       </div>
//     </>
//   );
// };

// export default Navbar;


import { useEffect, useState } from "react";
import { FaBars, FaTimes } from "react-icons/fa";
import { Link, useLocation } from "react-router-dom";
import loginToken from "../authComponents/localStorageItems/LoginTokin";
import baseURL from "../authComponents/baseURL/BaseURL";
import { ToastContainer, toast } from "react-toastify";
import { Alert } from "@mui/material";
import { handleCompatibilityTest } from "../../utils/compatibilityTest";
import RegionSwitcher from "./RegionSwitcher";
import { useGeo } from "../../utils/GeoContext";
import { sendGoodbye } from "../../hooks/useVisitorHeartbeat";

/* Inline toggle for mobile menu (avoids dropdown clipping from overflow-hidden) */
const MobileRegionSwitcher = () => {
  const { region, switchRegion } = useGeo();
  const opts = [
    { value: "pk", label: "🇵🇰 Pakistan" },
    { value: "standard", label: "🌐 Standard" },
  ];
  return (
    <>
      {opts.map((o) => (
        <button
          key={o.value}
          onClick={() => switchRegion(o.value)}
          className={`px-4 py-2 rounded-full text-xs font-semibold transition-colors ${
            region === o.value
              ? "bg-white text-gray-900"
              : "bg-white/15 text-white hover:bg-white/25"
          }`}
        >
          {o.label}
        </button>
      ))}
    </>
  );
};

const Navbar = ({
  userRole,
  userStatus,
  canRequestReview,
  userId,
  setLoginPopUp,
  isIncomepleteProfile,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  /* Plan of the signed-in member, so the nav can say "Upgrade Plan" to everyone
     who still has something to upgrade to, and plain "My Plan" to Elite/top-tier
     members (there is nothing above them to sell). */
  const [activePlan, setActivePlan] = useState(null);

  useEffect(() => {
    if (!loginToken) return;
    let cancelled = false;
    baseURL
      .get("/profile", { headers: { Authorization: `Bearer ${loginToken}` } })
      .then((res) => {
        if (!cancelled) setActivePlan(res.data?.data?.active_plan || "free");
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, []);

  const TOP_TIER_PLANS = ["select_elite", "select_queen", "select_vip"];
  const planLabel = TOP_TIER_PLANS.includes(String(activePlan)) ? "My Plan" : "Upgrade Plan";

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };
  const handleLogOut = () => {
    sendGoodbye();
    localStorage.removeItem("authToken");
    localStorage.removeItem("admin_impersonation");
    // Send the user to the top of the homepage. A plain reload made the browser
    // restore the old scroll position, so people landed in the footer.
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }
    window.scrollTo(0, 0);
    window.location.replace("/");
  };

  const userIsRejected = () => {
    return userStatus?.toLowerCase() === "rejected";
  };

  const userResubmitted = () => {
    return userStatus?.toLowerCase() === "resubmitted";
  };

  const getReviewButtonClass = () => {
    if (userIsRejected()) {
      return "inline-block px-5 py-2.5 rounded-lg text-sm font-medium text-white bg-gradient-to-r from-red-400 via-red-500 to-red-600 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-red-300 shadow-lg shadow-red-500/50 transition-all duration-300";
    }
    return "inline-block px-5 py-2.5 rounded-lg text-sm font-medium text-white bg-gray-300 cursor-not-allowed";
  };

  const getBannerText = () => {
    if (userIsRejected()) {
      return "Your profile is currently Rejected. Please update your profile from MyProfile Page and click this button to request admin for review of your updated information.";
    }
    return "✅ Your review request has been sent successfully. Please wait while an admin reviews your updated information. You will be notified once a decision is made.";
  };

  const requestAccess = async () => {
    try {
      const response = await baseURL.post(
        "/request_profile_review",
        { user_id: userId },
        { headers: { Authorization: `Bearer ${loginToken}` } }
      );
      if (response.status === 200) {
        toast.success(response.data.message);
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      } else {
        toast.error(response.data?.message || "Failed to request review. Please try again.");
      }
    } catch (error) {
      if (error.response?.status === 400) {
        toast.info("Please update your profile first, then request a review.");
      } else {
        toast.error("Something went wrong. Please try again.");
      }
      console.error("Error requesting access:", error);
    }
  };

  const getRequestAccessButton = () => {
    if (userIsRejected()) {
      return (
        <button
          type="button"
          onClick={requestAccess}
          className={getReviewButtonClass()}
        >
          Request Review
        </button>
      );
    }
    return (
      <button type="button" className={getReviewButtonClass()}>
        {userResubmitted() ? "Request Sent" : "Request Review"}
      </button>
    );
  };

  const handleLoginPopUp = () => {
    if (!loginToken) {
      setLoginPopUp(true);
    }
  };

  return (
    <>
      <ToastContainer />
      <div className="flex flex-col sticky top-0 left-0 z-50">
        {/* Incomplete Profile Alert */}
        {isIncomepleteProfile && loginToken && (
          <Alert
            severity="warning"
            className="text-center"
            sx={{ display: "flex", justifyContent: "center" }}
          >
            Your profile is incomplete. Please{" "}
            <Link to="/edit-profile" className="underline text-[#a30000] font-medium">
              update your profile
            </Link>{" "}
            to access all features.
          </Alert>
        )}

        {/* Rejected/Resubmitted Banner */}
        {loginToken && (userIsRejected() || userResubmitted()) && (
          <div className="flex flex-row items-center justify-center gap-4 p-3 bg-[#fffafa] border-b border-gray-200">
            <p className="text-sm text-gray-600 max-w-2xl">{getBannerText()}</p>
            {getRequestAccessButton()}
          </div>
        )}

        {/* Main Navigation - HTML Style Header */}
        <nav className="py-5 bg-gradient-to-r from-[#3b0000] to-[#7c0101]">
          <div
            className={`${
              loginToken ? "max-w-[1600px]" : "max-w-[1200px]"
            } mx-auto px-5 flex justify-between items-center gap-4`}
          >
            {/* Logo */}
            <Link to="/" className="flex items-center font-playfair text-xl md:text-2xl font-bold text-white">
              <img src="/Photos/Logo.webp" alt="Select Proposal logo" className="max-w-[59.781px] w-auto h-auto mr-2.5 inline-block" />
              <span className="inline-block align-middle">Select Proposal</span>
            </Link>

            {/* Mobile Menu Toggle */}
            <button
              onClick={toggleMenu}
              className="md:hidden text-white text-2xl p-2 hover:bg-white/10 rounded-lg transition-colors"
              aria-label="Toggle menu"
            >
              {isOpen ? (
                <FaTimes className="w-6 h-6" />
              ) : (
                <FaBars className="w-6 h-6" />
              )}
            </button>

            {/* Desktop Navigation Links */}
            <div className="hidden md:flex items-center gap-2.5 lg:gap-4">
              {/* Always-visible navigation links */}
              <Link
                to="/"
                className="text-white text-[13px] font-normal hover:opacity-80 transition-opacity whitespace-nowrap"
              >
                Home
              </Link>
              <Link
                to="/all-profiles"
                className="text-white text-[13px] font-normal hover:opacity-80 transition-opacity whitespace-nowrap"
              >
                View All Profiles
              </Link>
              <Link
                to="/how-we-are-different"
                className="text-white text-[13px] font-normal hover:opacity-80 transition-opacity whitespace-nowrap"
              >
                How We Are Different
              </Link>
              <Link
                to="/pricing"
                className="text-white text-[13px] font-normal hover:opacity-80 transition-opacity whitespace-nowrap"
              >
                Pricing
              </Link>

              {/* Logged-in only links */}
              {loginToken && (
                <>
                  <Link
                    to="/profile"
                    onClick={handleLoginPopUp}
                    className="text-white text-[13px] font-normal hover:opacity-80 transition-opacity whitespace-nowrap"
                  >
                    My Profile
                  </Link>
                  <Link
                    to="/my-plan"
                    className="text-white text-[13px] font-normal hover:opacity-80 transition-opacity whitespace-nowrap"
                  >
                    {planLabel}
                  </Link>
                  <Link
                    to="/my-shortlist"
                    className="text-white text-[13px] font-normal hover:opacity-80 transition-opacity whitespace-nowrap"
                  >
                    ♥ Shortlist
                  </Link>
                  <Link
                    to="/who-viewed-me"
                    className="text-white text-[13px] font-normal hover:opacity-80 transition-opacity whitespace-nowrap"
                  >
                    Profile Views
                  </Link>
                  <button
                    onClick={handleCompatibilityTest}
                    className="text-white text-[13px] font-normal hover:opacity-80 transition-opacity whitespace-nowrap text-left"
                  >
                    Compatibility Test
                  </button>
                  <Link
                    to="/my-plan#feature-my-profile"
                    className="inline-block px-3.5 py-1.5 rounded-full text-[13px] font-semibold whitespace-nowrap transition-all duration-300 hover:shadow-lg"
                    style={{ backgroundColor: "#F6C9A8", color: "#5A1212" }}
                  >
                    ★ Get me featured
                  </Link>
                  {(userRole === "admin" || userRole === "child_admin") && (
                    <Link
                      to="/admin/dashboard"
                      className="inline-block px-4 py-1.5 bg-white text-[#a30000] rounded-full text-[13px] font-semibold hover:shadow-lg transition-all duration-300"
                    >
                      Dashboard
                    </Link>
                  )}
                </>
              )}

              {/* Login/Join Now or Logout Button */}
              {!loginToken ? (
                <>
                  <Link
                    to="/login"
                    className="text-white text-[13px] font-normal hover:opacity-80 transition-opacity whitespace-nowrap"
                  >
                    Log in
                  </Link>
                  <Link
                    to="/signup"
                    className="inline-block bg-red-600 text-white font-semibold py-1.5 px-4 rounded-[50px] text-[13px] hover:opacity-90 transition-opacity"
                  >
                    Join Now
                  </Link>
                </>
              ) : (
                <button
                  onClick={handleLogOut}
                  className="inline-block bg-red-600 text-white font-semibold py-1.5 px-4 rounded-[50px] text-[13px] hover:opacity-90 transition-opacity"
                >
                  Log out
                </button>
              )}

              {/* Region Switcher */}
              <RegionSwitcher />
            </div>
          </div>

          {/* Mobile Navigation Menu */}
          <div
            className={`md:hidden absolute top-full left-0 w-full bg-gradient-to-r from-[#3b0000] to-[#7c0101] shadow-xl transition-all duration-300 ease-in-out ${
              isOpen
                ? "max-h-[calc(100dvh-72px)] overflow-y-auto overscroll-contain opacity-100"
                : "max-h-0 overflow-hidden opacity-0"
            }`}
          >
            <div className="flex flex-col pt-4 pb-10 px-5 space-y-1">
              {/* Always-visible links */}
              <Link
                to="/"
                onClick={toggleMenu}
                className="text-white py-3 px-4 rounded-lg hover:bg-white/10 transition-colors text-center font-medium"
              >
                Home
              </Link>
              <Link
                to="/all-profiles"
                onClick={toggleMenu}
                className="text-white py-3 px-4 rounded-lg hover:bg-white/10 transition-colors text-center font-medium"
              >
                View All Profiles
              </Link>
              <Link
                to="/how-we-are-different"
                onClick={toggleMenu}
                className="text-white py-3 px-4 rounded-lg hover:bg-white/10 transition-colors text-center font-medium"
              >
                How We Are Different
              </Link>
              <Link
                to="/pricing"
                onClick={toggleMenu}
                className="text-white py-3 px-4 rounded-lg hover:bg-white/10 transition-colors text-center font-medium"
              >
                Pricing
              </Link>

              {/* Logged-in only links */}
              {loginToken && (
                <>
                  <Link
                    to="/profile"
                    onClick={() => {
                      handleLoginPopUp();
                      toggleMenu();
                    }}
                    className="text-white py-3 px-4 rounded-lg hover:bg-white/10 transition-colors text-center font-medium"
                  >
                    My Profile
                  </Link>
                  <Link
                    to="/my-plan"
                    onClick={toggleMenu}
                    className="text-white py-3 px-4 rounded-lg hover:bg-white/10 transition-colors text-center font-medium"
                  >
                    {planLabel}
                  </Link>
                  <Link
                    to="/my-plan#feature-my-profile"
                    onClick={toggleMenu}
                    className="py-3 px-4 rounded-lg text-center font-semibold transition-colors"
                    style={{ backgroundColor: "#F6C9A8", color: "#5A1212" }}
                  >
                    ★ Get me featured
                  </Link>
                  <Link
                    to="/my-shortlist"
                    onClick={toggleMenu}
                    className="text-white py-3 px-4 rounded-lg hover:bg-white/10 transition-colors text-center font-medium"
                  >
                    ♥ Shortlist
                  </Link>
                  <Link
                    to="/who-viewed-me"
                    onClick={toggleMenu}
                    className="text-white py-3 px-4 rounded-lg hover:bg-white/10 transition-colors text-center font-medium"
                  >
                    Profile Views
                  </Link>
                  <button
                    onClick={() => {
                      handleCompatibilityTest();
                      toggleMenu();
                    }}
                    className="text-white py-3 px-4 rounded-lg hover:bg-white/10 transition-colors text-center font-medium"
                  >
                    Compatibility Test
                  </button>
                  {(userRole === "admin" || userRole === "child_admin") && (
                    <Link
                      to="/admin/dashboard"
                      onClick={toggleMenu}
                      className="text-white py-3 px-4 rounded-lg bg-[#a30000] hover:bg-[#8a0000] transition-colors text-center font-semibold mt-2"
                    >
                      Dashboard
                    </Link>
                  )}
                </>
              )}

              <div className={`pt-3 border-t border-white/20 ${loginToken ? 'mt-3' : ''}`}>
                {!loginToken ? (
                  <>
                    <Link
                      to="/login"
                      onClick={toggleMenu}
                      className="block py-3 px-4 text-white rounded-lg hover:bg-white/10 transition-colors text-center font-medium mb-2"
                    >
                      Log in
                    </Link>
                    <Link
                      to="/signup"
                      onClick={toggleMenu}
                      className="block py-3 px-4 bg-red-600 text-white rounded-[50px] text-center font-semibold hover:opacity-90 transition-opacity"
                    >
                      Join Now
                    </Link>
                  </>
                ) : (
                    <button
                      onClick={() => {
                        handleLogOut();
                        toggleMenu();
                      }}
                      className="w-full py-3 px-4 bg-red-600 text-white rounded-[50px] text-center font-semibold hover:opacity-90 transition-opacity"
                    >
                      Log out
                    </button>
                )}
              </div>

              {/* Mobile Region Switcher — inline buttons instead of dropdown to avoid overflow clip */}
              <div className="flex justify-center gap-3 pt-3 border-t border-white/10 mt-2">
                <MobileRegionSwitcher />
              </div>
            </div>
          </div>
        </nav>
      </div>
    </>
  );
};

export default Navbar;
